export const DEBUG_CHECK_INTERVAL_MS: number = 30e3;
